// Module H — Member Outreach Campaign Engine (Outreach Console)
// Cola de miembros sin visita reciente, contactabilidad y log de outreach.

import MemberOutreachPage from "./pages/MemberOutreachPage";

// Export routes for AppRouter
export const memberOutreachRoutes = [
  {
    path: "/member-outreach",
    element: <MemberOutreachPage />,
  },
];

// Export components for external use
export { default as MemberOutreachPage } from "./pages/MemberOutreachPage";
